import { api } from "./client";

export const moduleConfigsApi = {
  list: () => api.get("/module-configs").then((r) => r.data.moduleConfigs),
  get: (moduleKey) =>
    api.get(`/module-configs/${moduleKey}`).then((r) => r.data.moduleConfig),
  save: (moduleKey, config) =>
    api
      .put(`/module-configs/${moduleKey}`, { config })
      .then((r) => r.data.moduleConfig),
};
